import { makeStyles, Theme } from '@material-ui/core/styles'

/**
 * Styles for ClashIconButton component
 * Provides icon and badge styling
 */
export const useClashIconButtonStyles = makeStyles((theme: Theme) => ({
    warningIcon: {
        color: theme.palette.error.main,
    },
}))
